import { flow, pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { createAction } from '@mews/framework';
import { ApplicationState, CommanderThunkAction } from '@mews-commander/types';
import { ProductServiceOrder } from '@mews-commander/data-access';
import { sortByDescending } from '@mews-commander/utils';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'productServiceOrders';

const PRODUCT_SERVICE_ORDERS_LOADED = prefix('PRODUCT_SERVICE_ORDERS_LOADED');
const PRODUCT_SERVICE_ORDERS_UPDATED = prefix('PRODUCT_SERVICE_ORDERS_UPDATED');
const PRODUCT_SERVICE_ORDERS_DELETED = prefix('PRODUCT_SERVICE_ORDERS_DELETED');

export const setProductServiceOrders = (productServiceOrders: ProductServiceOrder[]) =>
    createAction(PRODUCT_SERVICE_ORDERS_LOADED, { entities: productServiceOrders });

export const productServiceOrdersReducer = createEntitiesReducer({
    FETCH_SUCCESS: PRODUCT_SERVICE_ORDERS_LOADED,
    UPDATE_SUCCESS: PRODUCT_SERVICE_ORDERS_UPDATED,
    DELETE_SUCCESS: PRODUCT_SERVICE_ORDERS_DELETED,
});

export const [
    getProductServiceOrders,
    getProductServiceOrdersByIds,
    getProductServiceOrdersByOwnerId,
    getProductServiceOrder,
] = createBaseEntitySelectors<ApplicationState, ProductServiceOrder, typeof NAME>(moduleSelector, NAME);

export const updateProductServiceOrder =
    (productServiceOrder: ProductServiceOrder): CommanderThunkAction =>
    (dispatch, getState) => {
        const productServiceOrders = getProductServiceOrders(getState());
        const entities = pipe(
            Object.values(productServiceOrders),
            array.map((item) => (item.id === productServiceOrder.id ? productServiceOrder : item))
        );

        return dispatch(createAction(PRODUCT_SERVICE_ORDERS_UPDATED, entities));
    };

export const getDescendingProductServiceOrdersByOwnerId = flow(
    getProductServiceOrdersByOwnerId,
    sortByDescending('createdUtc')
);
export const getNumberOfProductServiceOrders = flow(getProductServiceOrdersByOwnerId, array.size);
